export const ReportGroupOptions = [
    {code: 'day', name: 'По дням'},
    {code: 'week', name: 'По неделям'},
    {code: 'month', name: 'По месяцам'},
    {code: 'year', name: 'По годам'},
    {code: 'product', name: 'По товарам'},
    {code: 'brand', name: 'По брендам'},
    {code: 'store', name: 'По магазинам'},
    {code: 'marketplace', name: 'По маркетплейсам'},
]

export const ReportStatuses = [
    {code: 'cancelled', name: 'Отменен'},
    {code: 'returned', name: 'Возврат'},
    {code: 'processing', name: 'Обрабатывается'},
    {code: 'delivery', name: 'Доставляется'},
    {code: 'delivered', name: 'Доставлен'},
    {code: 'unknown', name: 'Не определен'}
]

export const OrderTypes = [
  {
    name: 'FBS',
    value: 'fbs',
  },
  {
    name: 'FBO/FBW',
    value: 'fbo',
  }
];
